import axios, { AxiosResponse } from "axios";
import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { ServerResponse_ } from "@/interfaces/Server";
import { ReturnRequest } from "@/interfaces/Return";
import { return_requests_url } from "@/constants/urls";

export async function getRequests(
  sellerId: string,
  source: number
): Promise<AxiosResponse<ServerResponse_<ReturnRequest[]>>> {
  const accessToken = store.getState().authentication.accessToken;
  try {
    const response: AxiosResponse<ServerResponse_<ReturnRequest[]>> =
      await axios({
        url: return_requests_url(sellerId, source),
        headers: defaultHeadersWithToken(accessToken),
        method: "GET",
      });
    return response;
  } catch (error: any) {
    return error.response;
  }
}
